import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { PasswordModel, PasswordFormModel } from './password-create.model';
import PasswordForm from './password-create.form';

import { State } from '../../reducers/index';
import { HIDE_HEADER, OVERLAY_START } from '../../actions/header.action';
import { INFO_DATA_SEND } from '../../actions/info.action';
import { Booking } from '../../actions/booking.action';

@Component({
  selector: 'consentz-password-create-component',
  templateUrl: './password-create.template.html',
  styleUrls: ['./password-create.styles.scss']
})
export class PasswordCreateComponent implements OnInit, OnDestroy {
  public model: PasswordModel = new PasswordModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  private booking$: any;
  private form: PasswordForm;

  constructor(
    private router: Router,
    private store: Store<State>
  ) {
    // hide header, create reactive form, subscribtion on widget options
    this.store.dispatch({ type: HIDE_HEADER });
    this.form = new PasswordForm(new PasswordFormModel());
    this.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
  }

  public ngOnInit(): void {}
  // unsubscribe from store
  public ngOnDestroy(): void {
    this.booking$.unsubscribe();
  }
  // set password
  private submit(): void {
    if (this.form.model.password === this.form.model.passwordConfirm) {
      this.store.dispatch({ type: OVERLAY_START });
      this.store.dispatch({
        type: INFO_DATA_SEND,
        payload: {
          data: this.form.model.password,
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/password-create/password-create.component.ts